import { isValid     ,
		 parse       } from 'date-fns';

export const isValidDate = ( dateStr: string , format = 'dd/MM/yyyy'): boolean => {

  const parsedDate = parse ( dateStr, format, new Date() );

  return ( isValid (parsedDate) )
}

